const forgotPasswordLink = document.querySelector(".toggle-forgot-password"),
  forgotPasswordForm = document.querySelector(".section-login__form--forgot"),
  loginLink = document.querySelector(".toggle-login"),
  loginForm = document.querySelector(".section-login__form--login");
forgotPasswordLink &&
  forgotPasswordForm &&
  forgotPasswordLink.addEventListener("click", function (o) {
    o.preventDefault(),
      forgotPasswordForm.classList.remove("hide"),
      forgotPasswordForm.classList.add("show"),
      loginForm.classList.add("hide"),
      loginForm.classList.remove("show");
  }),
  loginLink &&
    loginForm &&
    loginLink.addEventListener("click", function (o) {
      o.preventDefault(),
        loginForm.classList.remove("hide"),
        loginForm.classList.add("show"),
        forgotPasswordForm.classList.add("hide"),
        forgotPasswordForm.classList.remove("show");
    });
